import { Component } from '@angular/core';

@Component({
  selector: 'app-empty-member-table',
  templateUrl: './empty-member-table.component.html',
  styleUrl: './empty-member-table.component.scss',
})
export class EmptyMemberTableComponent {
  displayedColumns: string[] = [
    'memberType',
    'monday',
    'tuesday',
    'wednesday',
    'thursday',
    'friday',
    'saturday',
    'sunday',
  ];
}
